import api from '@/api';
import { API_BASE_URL } from '..';
import { HelpArea, HelpAreaQuery } from './HelpAreas.types';

const CONTROLLER_URL = `${API_BASE_URL}/helpareas`;

export async function listHelpAreas(params?: HelpAreaQuery) {
  const result = (await api.get(CONTROLLER_URL, params)) as unknown;
  return result as HelpArea[];
}

export async function getHelpArea(id?: number) {
  return api.get(`${CONTROLLER_URL}/${id}`, null) as unknown as HelpArea;
}
